import { TourSelectionContent } from './components/TourSelectionContent';

const ONBOARDING_COMPONENT_TYPES = {
  TOUR_SELECTION_CONTENT: 'tour-selection-content'
};

export const onboardingComponentsMap = {
  [ONBOARDING_COMPONENT_TYPES.TOUR_SELECTION_CONTENT]: TourSelectionContent
};
